import { BankAccountView } from 'models';

export function findLastModifiedMainBankAccount(
  bankAccounts: BankAccountView[]
) {
  let lastModifiedDate = 0;
  let lastModifiedMainBankAccount: BankAccountView | null = null;

  for (let bankAccount of bankAccounts) {
    if (!bankAccount.IsMain) continue;

    const modifiedDate = new Date(bankAccount.ModifiedOn).getTime();

    if (modifiedDate > lastModifiedDate) {
      lastModifiedDate = modifiedDate;
      lastModifiedMainBankAccount = { ...bankAccount };
    }
  }

  return lastModifiedMainBankAccount;
}
